exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profitAndLoss-0b311{padding:24px;border-radius:12px;background-color:#fff;box-shadow:0 4px 20px 0 rgba(112,112,128,.1);margin-bottom:24px;padding-left:0;padding-right:0}.profitAndLoss-0b311 .profitAndLossContainer-07f87{display:flex;justify-content:space-between;padding-right:24px}", ""]);

// Exports
exports.locals = {
	"profitAndLoss": "profitAndLoss-0b311",
	"profitAndLossContainer": "profitAndLossContainer-07f87"
};